// @ts-nocheck
import { SimpleQuoteFormFieldValues } from "@store/Framework/Store/Greif/Components/SimpleQuoteForm/SimpleQuoteFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof SimpleQuoteFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchSaveDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/SimpleQuoteForm/SaveDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchSaveDraftFieldValues];

const saveDraftFieldValues = createHandlerChainRunnerOptionalParameter(chain, [] as Parameter, "SaveDraftFieldValues");

export default saveDraftFieldValues;
